import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const useTags = (alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['tags'],
        fetchData: () => API.get('/tags'),
        returnDataKey: 'tags',
        defaultLoadingError: 'Failed to load tags.',
        saveAdditionalData: (response) => {
            response.map((tag) => {
                State.putIfNotExists(['tags', tag.id], tag);
                return tag;
            });
        },
        registerAdditionalMethods: (opts) => {
            return {
                saveTag: (data, id) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/tags${id ? '/'+id : ''}`, data),
                        'Tag saved',
                        true,
                    );
                },
                deleteTag: (tagId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/tags/${tagId}`),
                        'Tag deleted',
                        true,
                    );
                },
            }
        }
    });
}

const useTag = (tagId, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        block: !tagId,
        stateKey: ['tags', tagId],
        fetchData: () => API.get(`/tags/${tagId}`),
        returnDataKey: 'tag',
        defaultLoadingError: 'Failed to load tag.',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/tags/${tagId}`, data),
                        'Tag updated',
                        true,
                    );
                },
                delete: () => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/tags/${tagId}`),
                        'Tag deleted',
                        true,
                    );
                },
            }
        },
    });
}

const colours = {
    Red: {
        real: true,
        name: 'Red',
        fill: 'fill-red-600',
        bg: 'bg-red-600',
        bgLight: 'bg-red-50',
        text: 'text-red-600',
        border: 'border-red-200',
        borderMuted: 'border-red-100',
    },
    Blue: {
        real: true,
        name: 'Blue',
        fill: 'fill-blue-600',
        bg: 'bg-blue-600',
        bgLight: 'bg-blue-50',
        text: 'text-blue-600',
        border: 'border-blue-200',
        borderMuted: 'border-blue-100',
    },
    Green: {
        real: true,
        name: 'Green',
        fill: 'fill-green-600',
        bg: 'bg-green-600',
        bgLight: 'bg-green-50',
        text: 'text-green-600',
        border: 'border-green-200',
        borderMuted: 'border-green-100',
    },
    Slate: {
        real: true,
        name: 'Slate',
        fill: 'fill-slate-500',
        bg: 'bg-slate-500',
        bgLight: 'bg-slate-50',
        text: 'text-slate-500',
        border: 'border-slate-200',
        borderMuted: 'border-slate-100',
    },
    Gray: {
        real: false,
        name: 'Slate',
        fill: 'fill-gray-400',
        bg: 'bg-gray-400',
        bgLight: 'bg-gray-50',
        text: 'text-gray-400',
        border: 'border-gray-100',
        borderMuted: 'border-gray-50',
    },
};

const icons = [
    // 'Check',
    'CircleInfo',
    'Dog',
    'Droplet',
    'FaceSmile',
    'Fence',
    'Fire',
    'Flag',
    'Hand',
    'Heart',
    'Sack',
    'Star',
    'Tag',
    'Tap',
    'ThumbsDown',
    'ThumbsUp',
    'TriangleExclamation',
    'Trophy',
    'XMark',
];

export {
    useTags,
    useTag,
    colours,
    icons,
};